var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as Long from "long";
import { utilTime } from "../../../utils/utilTime";
import { TypeActionProductionInfo } from "./actionProductionInfo";
var initial = {
    playerId: Long.ZERO,
    productions: [],
    removedProductions: [],
};
export var reducerProductionInfoReceived = function (state, action) {
    if (state === void 0) { state = initial; }
    if (action.type === TypeActionProductionInfo.Received && action.productionInfo != undefined) {
        return __assign({}, state, action.productionInfo, { productions: action.productionInfo.productions
                ? action.productionInfo.productions.map(transformProduction)
                : [] });
    }
    else if (action.type === TypeActionProductionInfo.Remove) {
        var removedProduction = state.productions.find(function (p) { return p.buildingId === action.buildingId; });
        var removedProductions = removedProduction
            ? state.removedProductions.concat([__assign({}, removedProduction, { timestamp: utilTime.now() })]) : state.removedProductions;
        return __assign({}, state, { productions: state.productions.filter(function (prod) { return prod.buildingId !== action.buildingId; }), removedProductions: removedProductions });
    }
    else if (action.type === TypeActionProductionInfo.ConfirmRemove) {
        var removedProduction = state.removedProductions.find(function (prod) { return prod.buildingId === action.buildingId; });
        if (removedProduction != undefined) {
            return __assign({}, state, { removedProductions: state.removedProductions.filter(function (prod) { return prod.buildingId !== action.buildingId; }) });
        }
        var reAddedProduction = state.productions.find(function (prod) { return prod.buildingId === action.buildingId && prod.hasOwnProperty("timestamp"); });
        if (reAddedProduction != undefined) {
            return __assign({}, state, { productions: state.productions.filter(function (prod) {
                    return prod.buildingId !== action.buildingId || !prod.hasOwnProperty("timestamp");
                }) });
        }
    }
    else if (action.type === TypeActionProductionInfo.ReAdd) {
        var removedProduction = state.removedProductions.find(function (p) { return p.buildingId === action.buildingId; });
        var productions = removedProduction
            ? state.productions.concat([removedProduction]) : state.productions;
        return __assign({}, state, { productions: productions, removedProductions: state.removedProductions.filter(function (prod) { return prod.buildingId !== action.buildingId; }) });
    }
    else if (action.type === TypeActionProductionInfo.Finish) {
        return __assign({}, state, { productions: state.productions.map(function (prod) {
                return prod.buildingId !== action.buildingId
                    ? prod
                    : __assign({}, prod, { remainingTime: undefined });
            }) });
    }
    else if (action.type === TypeActionProductionInfo.Add && action.production) {
        return __assign({}, state, { productions: state.productions.concat([transformProduction(action.production)]) });
    }
    else if (action.type === TypeActionProductionInfo.Update && action.production) {
        return __assign({}, state, { productions: state.productions.filter(function (prod) { return prod.buildingId !== action.buildingId; }).concat([
                transformProduction(action.production),
            ]) });
    }
    return state;
};
var transformProduction = function (prod) { return (__assign({}, prod, { remainingTime: prod.remainingTime
        ? utilTime.remainingTimeToTimestamp(prod.remainingTime)
        : undefined })); };



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/reducerProductionInfo.ts
// module id = 2540
// module chunks = 3